import { render, staticRenderFns } from "./Carousel3d.vue?vue&type=template&id=57f34663&scoped=true&"
import script from "./Carousel3d.vue?vue&type=script&lang=js&"
export * from "./Carousel3d.vue?vue&type=script&lang=js&"
import style0 from "./Carousel3d.vue?vue&type=style&index=0&id=57f34663&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f34663",
  null
  
)

export default component.exports